import { render, staticRenderFns } from "./ScrollToTopButton.vue?vue&type=template&id=c7507712"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollToTopButton.vue?vue&type=style&index=0&id=c7507712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports